/**
 * Standard-Text «Über uns» (Team-Seite).
 * Im Admin unter Site → Über uns Text einfügen, oder als Fallback aktiv.
 */
export const GARAGE_ABOUT_HTML = `
<p>
  Die <strong>Sportplatzgarage Gutknecht GmbH</strong> in Davos ist Ihre Werkstatt mit
  kurzen Wegen und echtem Ansprechpartner – nicht eine anonyme Service-Kette.
  Als offizieller <strong>stop+go Partner</strong> sind wir spezialisiert auf
  <strong>Volkswagen, Audi, SEAT, Škoda und CUPRA</strong>: Service, Diagnose und
  Reparatur nach Herstellervorgaben, mit fairen Preisen und klarer Kommunikation.
</p>
<p>
  Das stop+go Konzept wird von der <strong>AMAG Import AG</strong> unterstützt.
  Das bedeutet für Sie: Zugang zu Originalteilen wo sinnvoll, aktuelle Diagnosetechnik
  und das Know-how eines schweizweiten Netzwerks – kombiniert mit der persönlichen
  Betreuung einer regionalen Garage an der <strong>Mattastrasse 46</strong>.
</p>
<p><strong>Was wir für Sie tun</strong></p>
<ul>
  <li>Service, Reparatur &amp; Diagnose für VW, Audi, SEAT, Škoda &amp; CUPRA</li>
  <li>Pannendienst &amp; Mobilitätsgarantie stop+go</li>
  <li>Carrosserie, Lackiererei &amp; Verglasung</li>
  <li>Schadenabwicklung &amp; Unfallbergung</li>
  <li>Autovermietung über <a href="https://www.stiffler-fahrzeugvermietung.ch/" target="_blank" rel="noopener noreferrer">Stiffler Fahrzeugvermietung</a></li>
  <li>Ölspurreinigung, Schächte absaugen &amp; Belagsreinigung</li>
</ul>
<p>
  Ob Familienauto, Firmenwagen oder Allrad in der Bündner Wintersaison: Wir erklären,
  was wirklich nötig ist, erstellen verständliche Offerten und halten Termine ein.
  Sie sprechen mit Menschen, die Ihr Fahrzeug kennen – nicht mit einem Callcenter.
</p>
<p>
  <strong>Überzeugen Sie sich selbst.</strong> Kommen Sie vorbei, rufen Sie uns an unter
  <a href="tel:+41814132720">081 413 27 20</a> oder buchen Sie direkt einen
  <a href="/online-termin">Online-Termin</a>.
</p>
`.trim();

export const GARAGE_ABOUT_TITLE = 'Ihre Garage in Davos – persönlich, kompetent, fair';
